export default __webpack_public_path__ + "static/media/e7.f02b2d33.jpg";